import { ElementType, IElement } from '../../../models/Element';

export type PluginLeftImageInfoNoButtons = IElement & {
  image: string;
  image_alt: string;
  heading: string;
  description: string;
};

export const defaultPluginLeftImageInfoNoButtons: PluginLeftImageInfoNoButtons =
  {
    id: 0,
    name: ElementType.PLUGIN_LEFT_IMAGE_INFO_NO_BUTTONS,
    image: '',
    image_alt: '',
    heading: 'Werking van de plugin.',
    description:
      'Voor makelaars is het van groot belang dat objecten (woningen en BOG) goed vindbaar zijn voor potentiële kopers. Dit kan tegenwoordig via Funda, Jaap en andere woningsites, maar ook de eigen website van de makelaar is hierin van essentieel belang.',
  };
